/**
 * International Postal Code Validation
 * Supports validation for postal codes across different countries
 */

// Country list with postal code formats - sorted alphabetically by name
export const ALL_COUNTRIES = [
  { code: 'US', name: 'United States', flag: '🇺🇸', postalFormat: /^\d{5}(-\d{4})?$/ },
  { code: 'CA', name: 'Canada', flag: '🇨🇦', postalFormat: /^[A-Za-z]\d[A-Za-z][ -]?\d[A-Za-z]\d$/ },
  { code: 'GB', name: 'United Kingdom', flag: '🇬🇧', postalFormat: /^[A-Z]{1,2}\d[A-Z\d]? ?\d[A-Z]{2}$/i },
  { code: 'AU', name: 'Australia', flag: '🇦🇺', postalFormat: /^\d{4}$/ },
  { code: 'DE', name: 'Germany', flag: '🇩🇪', postalFormat: /^\d{5}$/ },
  { code: 'FR', name: 'France', flag: '🇫🇷', postalFormat: /^\d{5}$/ },
  { code: 'IT', name: 'Italy', flag: '🇮🇹', postalFormat: /^\d{5}$/ },
  { code: 'ES', name: 'Spain', flag: '🇪🇸', postalFormat: /^\d{5}$/ },
  { code: 'NL', name: 'Netherlands', flag: '🇳🇱', postalFormat: /^\d{4} ?[A-Z]{2}$/i },
  { code: 'BE', name: 'Belgium', flag: '🇧🇪', postalFormat: /^\d{4}$/ },
  { code: 'CH', name: 'Switzerland', flag: '🇨🇭', postalFormat: /^\d{4}$/ },
  { code: 'AT', name: 'Austria', flag: '🇦🇹', postalFormat: /^\d{4}$/ },
  { code: 'SE', name: 'Sweden', flag: '🇸🇪', postalFormat: /^\d{3} ?\d{2}$/ },
  { code: 'NO', name: 'Norway', flag: '🇳🇴', postalFormat: /^\d{4}$/ },
  { code: 'DK', name: 'Denmark', flag: '🇩🇰', postalFormat: /^\d{4}$/ },
  { code: 'FI', name: 'Finland', flag: '🇫🇮', postalFormat: /^\d{5}$/ },
  { code: 'PL', name: 'Poland', flag: '🇵🇱', postalFormat: /^\d{2}-\d{3}$/ },
  { code: 'NZ', name: 'New Zealand', flag: '🇳🇿', postalFormat: /^\d{4}$/ },
  { code: 'JP', name: 'Japan', flag: '🇯🇵', postalFormat: /^\d{3}-\d{4}$/ },
  { code: 'IN', name: 'India', flag: '🇮🇳', postalFormat: /^\d{6}$/ },
  { code: 'CN', name: 'China', flag: '🇨🇳', postalFormat: /^\d{6}$/ },
  { code: 'BR', name: 'Brazil', flag: '🇧🇷', postalFormat: /^\d{5}-?\d{3}$/ },
  { code: 'MX', name: 'Mexico', flag: '🇲🇽', postalFormat: /^\d{5}$/ },
  { code: 'AR', name: 'Argentina', flag: '🇦🇷', postalFormat: /^[A-Z]?\d{4}[A-Z]{0,3}$/i },
  { code: 'ZA', name: 'South Africa', flag: '🇿🇦', postalFormat: /^\d{4}$/ },
  { code: 'SG', name: 'Singapore', flag: '🇸🇬', postalFormat: /^\d{6}$/ },
  { code: 'MY', name: 'Malaysia', flag: '🇲🇾', postalFormat: /^\d{5}$/ },
  { code: 'TH', name: 'Thailand', flag: '🇹🇭', postalFormat: /^\d{5}$/ },
  { code: 'PH', name: 'Philippines', flag: '🇵🇭', postalFormat: /^\d{4}$/ },
  { code: 'ID', name: 'Indonesia', flag: '🇮🇩', postalFormat: /^\d{5}$/ },
  { code: 'KR', name: 'South Korea', flag: '🇰🇷', postalFormat: /^\d{5}$/ },
  { code: 'TR', name: 'Turkey', flag: '🇹🇷', postalFormat: /^\d{5}$/ },
  { code: 'RU', name: 'Russia', flag: '🇷🇺', postalFormat: /^\d{6}$/ },
  { code: 'IL', name: 'Israel', flag: '🇮🇱', postalFormat: /^\d{5,7}$/ },
  { code: 'AE', name: 'United Arab Emirates', flag: '🇦🇪', postalFormat: /^.{3,}$/ },
  { code: 'SA', name: 'Saudi Arabia', flag: '🇸🇦', postalFormat: /^\d{5}(-\d{4})?$/ },
  { code: 'EG', name: 'Egypt', flag: '🇪🇬', postalFormat: /^\d{5}$/ },
  { code: 'PK', name: 'Pakistan', flag: '🇵🇰', postalFormat: /^\d{5}$/ },
  { code: 'BD', name: 'Bangladesh', flag: '🇧🇩', postalFormat: /^\d{4}$/ },
  { code: 'VN', name: 'Vietnam', flag: '🇻🇳', postalFormat: /^\d{5,6}$/ },
  { code: 'CL', name: 'Chile', flag: '🇨🇱', postalFormat: /^\d{7}$/ },
  { code: 'CO', name: 'Colombia', flag: '🇨🇴', postalFormat: /^\d{6}$/ },
  { code: 'PE', name: 'Peru', flag: '🇵🇪', postalFormat: /^\d{5}$/ },
  { code: 'VE', name: 'Venezuela', flag: '🇻🇪', postalFormat: /^\d{4}$/ },
  { code: 'EC', name: 'Ecuador', flag: '🇪🇨', postalFormat: /^\d{6}$/ },
  { code: 'UY', name: 'Uruguay', flag: '🇺🇾', postalFormat: /^\d{5}$/ },
  { code: 'PY', name: 'Paraguay', flag: '🇵🇾', postalFormat: /^\d{4}$/ },
  { code: 'BO', name: 'Bolivia', flag: '🇧🇴', postalFormat: /^\d{4}$/ },
  { code: 'CR', name: 'Costa Rica', flag: '🇨🇷', postalFormat: /^\d{5}$/ },
  { code: 'PA', name: 'Panama', flag: '🇵🇦', postalFormat: /^\d{4}$/ },
  { code: 'DO', name: 'Dominican Republic', flag: '🇩🇴', postalFormat: /^\d{5}$/ },
  { code: 'GT', name: 'Guatemala', flag: '🇬🇹', postalFormat: /^\d{5}$/ },
  { code: 'HN', name: 'Honduras', flag: '🇭🇳', postalFormat: /^\d{5}$/ },
  { code: 'SV', name: 'El Salvador', flag: '🇸🇻', postalFormat: /^\d{4}$/ },
  { code: 'NI', name: 'Nicaragua', flag: '🇳🇮', postalFormat: /^\d{3}-\d{3}-\d{1}$/ },
  { code: 'CU', name: 'Cuba', flag: '🇨🇺', postalFormat: /^\d{5}$/ },
  { code: 'JM', name: 'Jamaica', flag: '🇯🇲', postalFormat: /^.{3,}$/ },
  { code: 'TT', name: 'Trinidad and Tobago', flag: '🇹🇹', postalFormat: /^.{3,}$/ },
  { code: 'BB', name: 'Barbados', flag: '🇧🇧', postalFormat: /^BB\d{5}$/i },
  { code: 'BS', name: 'Bahamas', flag: '🇧🇸', postalFormat: /^.{3,}$/ },
  { code: 'IS', name: 'Iceland', flag: '🇮🇸', postalFormat: /^\d{3}$/ },
  { code: 'LU', name: 'Luxembourg', flag: '🇱🇺', postalFormat: /^\d{4}$/ },
  { code: 'PT', name: 'Portugal', flag: '🇵🇹', postalFormat: /^\d{4}-\d{3}$/ },
  { code: 'GR', name: 'Greece', flag: '🇬🇷', postalFormat: /^\d{3} ?\d{2}$/ },
  { code: 'CZ', name: 'Czech Republic', flag: '🇨🇿', postalFormat: /^\d{3} ?\d{2}$/ },
  { code: 'HU', name: 'Hungary', flag: '🇭🇺', postalFormat: /^\d{4}$/ },
  { code: 'RO', name: 'Romania', flag: '🇷🇴', postalFormat: /^\d{6}$/ },
  { code: 'BG', name: 'Bulgaria', flag: '🇧🇬', postalFormat: /^\d{4}$/ },
  { code: 'HR', name: 'Croatia', flag: '🇭🇷', postalFormat: /^\d{5}$/ },
  { code: 'SI', name: 'Slovenia', flag: '🇸🇮', postalFormat: /^\d{4}$/ },
  { code: 'SK', name: 'Slovakia', flag: '🇸🇰', postalFormat: /^\d{3} ?\d{2}$/ },
  { code: 'EE', name: 'Estonia', flag: '🇪🇪', postalFormat: /^\d{5}$/ },
  { code: 'LV', name: 'Latvia', flag: '🇱🇻', postalFormat: /^LV-\d{4}$/i },
  { code: 'LT', name: 'Lithuania', flag: '🇱🇹', postalFormat: /^LT-\d{5}$/i },
  { code: 'MT', name: 'Malta', flag: '🇲🇹', postalFormat: /^[A-Z]{3} ?\d{2,4}$/i },
  { code: 'CY', name: 'Cyprus', flag: '🇨🇾', postalFormat: /^\d{4}$/ },
  { code: 'IE', name: 'Ireland', flag: '🇮🇪', postalFormat: /^[A-Z]\d{2} ?[A-Z0-9]{4}$/i },
];

// Launch setting: keep the product US-only until tax and regional pricing are ready.
const ENABLE_US_ONLY_LAUNCH = true;

// Sort countries alphabetically by name
export const COUNTRIES = ALL_COUNTRIES
  .filter(country => !ENABLE_US_ONLY_LAUNCH || country.code === 'US')
  .map(country => ({
    ...country,
    postalFormat: country.postalFormat || /^.{3,}$/ // Default: at least 3 characters
  }))
  .sort((a, b) => a.name.localeCompare(b.name));

// Get country by code
export const getCountryByCode = (code) => {
  const allCountries = ALL_COUNTRIES.map(country => ({
    ...country,
    postalFormat: country.postalFormat || /^.{3,}$/
  }));
  return allCountries.find(c => c.code === code) || allCountries.find(c => c.code === 'US') || allCountries[0];
};

// Validate postal code for a country
export const validatePostalCode = (postalCode, countryCode) => {
  if (!postalCode || !countryCode) return { valid: false, message: 'Postal code and country are required' };
  
  const country = getCountryByCode(countryCode);
  const cleanedCode = postalCode.trim().toUpperCase();
  
  // Test against the regex pattern
  const isValid = country.postalFormat.test(cleanedCode);
  
  if (!isValid) {
    return {
      valid: false,
      message: `Please enter a valid ${country.name} postal code`
    };
  }
  
  return { valid: true, message: '' };
};

// Get placeholder text for a country
export const getPostalCodePlaceholder = (countryCode) => {
  const placeholders = {
    'US': '12345',
    'CA': 'A1A 1A1',
    'GB': 'SW1A 1AA',
    'AU': '2000',
    'DE': '10115',
    'FR': '75001',
    'IT': '00118',
    'ES': '28001',
    'NL': '1012 AB',
    'BE': '1000',
    'CH': '8001',
    'AT': '1010',
    'SE': '123 45',
    'NO': '0001',
    'DK': '1000',
    'FI': '00100',
    'PL': '12-345',
    'IE': 'D02 AF30',
    'NZ': '1010',
    'JP': '100-0001',
    'IN': '110001',
    'CN': '100000',
    'BR': '01310-100',
    'MX': '01000',
    'AR': 'C1000',
    'ZA': '0001',
    'SG': '018956',
    'MY': '50000',
    'TH': '10100',
    'PH': '1000',
    'ID': '10110',
    'KR': '03051',
    'TR': '34000',
    'RU': '101000',
    'IL': '9100001',
    'SA': '11564',
    'EG': '11511',
    'PK': '44000',
    'BD': '1000',
    'VN': '70000',
    'CL': '8320000',
    'CO': '110111',
    'PE': '15001',
    'VE': '1010',
    'EC': '170101',
    'UY': '11000',
    'PY': '1000',
    'BO': '0001',
    'CR': '10101',
    'PA': '0801',
    'DO': '10101',
    'GT': '01001',
    'HN': '31301',
    'SV': '1101',
    'NI': '100-000-1',
    'CU': '10100',
    'BB': 'BB11000',
    'IS': '101',
    'LU': '1009',
    'PT': '1000-001',
    'GR': '101 31',
    'CZ': '110 00',
    'HU': '1011',
    'RO': '010001',
    'BG': '1000',
    'HR': '10000',
    'SI': '1000',
    'SK': '010 01',
    'EE': '10111',
    'LV': 'LV-1001',
    'LT': 'LT-00001',
    'MT': 'VLT 1000',
    'CY': '1000',
  };
  
  return placeholders[countryCode] || 'Enter postal code';
};

// Get input pattern for HTML5 validation
export const getPostalCodePattern = (countryCode) => {
  const country = getCountryByCode(countryCode);
  // Convert regex to HTML5 pattern (simplified)
  const pattern = country.postalFormat.toString();
  // Remove regex delimiters and flags
  return pattern.replace(/^\/|\/[gimuy]*$/g, '');
};

// Format postal code (basic formatting, can be enhanced)
export const formatPostalCode = (postalCode, countryCode) => {
  if (!postalCode) return '';
  
  const cleaned = postalCode.trim().toUpperCase().replace(/\s+/g, '');
  
  // Basic formatting for common patterns
  if (countryCode === 'US') {
    if (cleaned.length === 9) {
      return `${cleaned.slice(0, 5)}-${cleaned.slice(5)}`;
    }
    return cleaned.slice(0, 5);
  }
  
  if (countryCode === 'CA') {
    // Format: A1A 1A1
    if (cleaned.length >= 3) {
      return `${cleaned.slice(0, 3)} ${cleaned.slice(3, 6)}`;
    }
  }
  
  if (countryCode === 'GB') {
    // Format: SW1A 1AA (simplified)
    if (cleaned.length >= 5) {
      return `${cleaned.slice(0, -3)} ${cleaned.slice(-3)}`;
    }
  }
  
  // Return as-is for other countries (can be enhanced)
  return cleaned;
};
